import { render, staticRenderFns } from "./exportDelete.vue?vue&type=template&id=1a45f375"
import script from "./exportDelete.vue?vue&type=script&lang=js"
export * from "./exportDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports